import HelenAPI from "@helen/sdk";
import AppBar from "@material-ui/core/AppBar";
import { withStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import React from "react";
import { BrowserRouter as Router, Redirect, Route } from "react-router-dom";
import ApiSelector from "./components/ApiSelector";
import LanguageSelector from "./components/LanguageSelector";
import Recorder from "./components/Recorder";
import SignIn from "./components/SignIn";

const styles = () => ({
  root: {
    flexGrow: 1,
    display: "flex",
    flexWrap: "wrap"
  },
  flex: {
    flex: 1,
    color: "#999",
    fontWeight: "normal",
    fontSize: 40
  },
  content: {
    width: "100%"
  },
  appBar: {
    zIndex: 0
  }
});

class App extends React.Component {
  state = {
    mainLanguageId: null,
    secondaryLanguageId: null,
    version: null,
    showAppBar: true
  };

  setLanguage = ({ mainLanguageId, secondaryLanguageId }) =>
    this.setState({ mainLanguageId, secondaryLanguageId });
  setAppBar = value => {
    this.setState({ showAppBar: value });
  };
  setVersion = ({ version }) =>
    this.setState({version});

  render() {
    const { classes } = this.props;
    return (
      <Router>
        <div className={classes.root}>
          {this.state.showAppBar && (
            <AppBar
              position="static"
              color="default"
              className={classes.appBar}
            >
              <Toolbar>
                <Typography
                  variant="headline"
                  className={classes.flex}
                  align="center"
                >
                  Helen Recording Interface
                </Typography>
              </Toolbar>
            </AppBar>
          )}
          <div className={classes.content}>
            <Route
              path="/"
              exact
              render={() => {
                if (HelenAPI.getBaseUrl()) {
                  return <Redirect to="/signin" />;
                }
                return <Redirect to="/select-api" />;
              }}
            />
            <Route
              path="/select-api"
              render={() => <ApiSelector onNext="/signin" />}
            />
            <Route
              path="/signin"
              render={() => <SignIn onNext="/select-language" />}
            />
            <Route
              path="/select-language"
              exact
              render={() => (
                <LanguageSelector
                  onNext="/recorder"
                  setLanguage={this.setLanguage}
                  setVersion={this.setVersion}
                />
              )}
            />
            <Route
              path="/recorder"
              exact
              render={() => (
                <Recorder
                  languages={{
                    main: this.state.mainLanguageId,
                    secondary: this.state.secondaryLanguageId
                  }}
                  version={this.state.version}
                  setAppBar={this.setAppBar}
                  onNext="/signin"
                />
              )}
            />
          </div>
        </div>
      </Router>
    );
  }
}

App.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(App);



// WEBPACK FOOTER //
// ./src/App.jsx